module.exports = __webpack_public_path__ + "static/media/material-folder.f78acb64.svg";